<template>
  <div id="map-container" ref="map"></div>
</template>

<script>
import mapPoint from '@/assets/mapPoint.svg'
import point1PL from '@/assets/mapPoint1PL.svg'

export default {
  name: 'BasicMap',
  data () {
    return {
      localDrops: {},
      herePlatform: null,
      hereRouting: null,
      hereDefaultLayer: null,
      hereMap: null,
      hereMapBehaviors: null,
      hereMapUI: {
        source: null,
        mapSettings: null,
        zoom: null,
        scalebar: null
      },
      hereMarker1PL: null,
      hereMarkerIcon: null,
      hereRoutingMode: 'balanced;truck',
      hereRoutingRepresentation: 'display'
    }
  },
  computed: {
    coordinates () {
      let coordsArr = []
      let coordsString = this.$route.params.coords
      let coords = coordsString.split('+')
      coords.forEach(pair => {
        let res = pair.split(',')
        coordsArr.push({ lat: parseFloat(res[0]), lng: parseFloat(res[1]), position: 0, agregated: '' })
      })

      let position = 0
      for (let i = 1; i < coordsArr.length; i++) {
        const element = coordsArr[i]
        const prevElement = coordsArr[i - 1]
        if (element.lng !== prevElement.lng || element.lat !== prevElement.lat) {
          position++
        }
        coordsArr[i].position = position
      }
      coordsArr.forEach((thing, index, self) => {
        let same = new Set()
        self.forEach((t, i) => {
          if (t.lat === thing.lat && t.lng === thing.lng && t.position !== thing.position) {
            same.add(thing.position)
            same.add(t.position)
          }
        })
        same = Array.from(same)
        same.sort(function (a, b) { return a - b })
        same.forEach((el, i) => {
          if (i === 0) {
            thing.agregated = el
          } else {
            thing.agregated = thing.agregated + ', ' + el
          }
        })
      })
      return coordsArr
    }
  },
  mounted () {
    this.initializeHereMapSources().then(() => {
      this.initializeHereMap()
      this.initializeHereMapUI()
      this.calculateHereMapRoute()
    })
  },
  methods: {
    initializeHereMap () {
      this.herePlatform = new window.H.service.Platform({
        apikey: 'nnuTL4coE1diqkZ9mDdzC7shaHo7hJrtZmeHfd1mRzU',
        app_code: 'PROD-de11fa5f-5a46-49b7-bdc9-b09879cdb583',
        useCIT: true,
        useHTTPS: true
      })
      // Routing Service
      this.hereRouting = this.herePlatform.getRoutingService()
      this.hereDefaultLayer = this.herePlatform.createDefaultLayers({
        lg: this.$i18n.locale
      })
      this.hereMap = new window.H.Map(
        this.$refs.map,
        this.hereDefaultLayer.vector.normal.map,
        {
          zoom: 7,
          center: { lat: 49.2306525, lng: 16.59019349999994 },
          pixelRatio: window.devicePixelRatio || 1
        }
      )
      var mapEvents = new window.H.mapevents.MapEvents(this.hereMap)
      this.hereMapBehaviors = new window.H.mapevents.Behavior(mapEvents)
      window.addEventListener('resize', () => {
        this.hereMap.getViewPort().resize()
      })
    },
    initializeHereMapUI () {
      this.hereMapUI.source = window.H.ui.UI.createDefault(this.hereMap, this.hereDefaultLayer)
      this.mapSettings = this.hereMapUI.source.getControl('mapsettings')
      this.zoom = this.hereMapUI.source.getControl('zoom')
      this.scalebar = this.hereMapUI.source.getControl('scalebar')
    },
    async initializeHereMapSources () {
      const icon1PL = await fetch(point1PL).then(r => r.text())
      const mapIcon = await fetch(mapPoint).then(r => r.text())
      this.hereMarker1PL = new window.H.map.DomIcon(icon1PL)
      this.hereMarkerIcon = new window.H.map.DomIcon(mapIcon)
    },
    calculateHereMapRoute () {
      let routingOptions = {}
      let routingMarkers = []
      routingOptions['mode'] = this.hereRoutingMode
      routingOptions['representation'] = this.hereRoutingRepresentation
      this.coordinates.forEach((coordinate, index) => {
        routingOptions[`waypoint${index}`] = `${coordinate.lat},${coordinate.lng}`
        let marker = null
        // if (index === 0 || index === this.coordinates.length - 1) {
        //   marker = new window.H.map.DomMarker(
        //     {
        //       lat: coordinate.lat,
        //       lng: coordinate.lng
        //     },
        //     { icon: this.hereMarkerIcon }
        //   )
        // } else {
        //   marker = new window.H.map.DomMarker(
        //     {
        //       lat: coordinate.lat,
        //       lng: coordinate.lng
        //     },
        //     { icon: this.hereMarker1PL }
        //   )
        // }

        let svgMarkup = '<svg width="24" height="24" ' +
    'xmlns="http://www.w3.org/2000/svg">' +
    '<rect stroke="white" fill="#1b468d" x="1" y="1" width="22" ' +
    'height="22" /><text x="12" y="18" font-size="10pt" ' +
    'font-family="Arial" font-weight="bold" text-anchor="middle" ' +
    'fill="white">' + (coordinate.agregated === '' ? coordinate.position : coordinate.position + '*') + '</text></svg>'

        let icon = new window.H.map.DomIcon(svgMarkup)

        marker = new window.H.map.DomMarker(
          {
            lat: coordinate.lat,
            lng: coordinate.lng
          },
          { icon: icon }
        )

        marker.setData(`<div class="custom--timeline__body--card">
        <div class="custom--timeline__body--card--text">
        <span class="custom--timeline__body--card--text__title">${(coordinate.agregated === '' ? coordinate.position : coordinate.agregated)}</span>
        <span class="custom--timeline__body--card--text__title"><b>Lat: </b>${coordinate.lat}</span>
        <span class="custom--timeline__body--card--text__title"><b>Lng: </b>${coordinate.lng}</span>
        </div>
        </div>`
        )
        routingMarkers.push(marker)
      })
      this.hereRouting.calculateRoute(routingOptions, this.onRoutingResult.bind(null, routingMarkers), this.onRoutingError)
    },
    onRoutingResult (markers, result) {
      result.response.route.forEach((route) => {
        this.drawHereMapRoute(route)
        this.drawHereMapMarkers(markers)
        this.drawHereMapMarkersBubbles(markers)
      })
    },
    onRoutingError (error) {
      console.log(error)
    },
    drawHereMapRoute (route) {
      let routeShape = route.shape
      let lineString = new window.H.geo.LineString()
      routeShape.forEach((point) => {
        lineString.pushLatLngAlt(point.split(',')[0], point.split(',')[1])
      })
      let routeLine = new window.H.map.Polyline(lineString, {
        style: {
          strokeColor: '#4CAF50',
          fillColor: 'transparent',
          lineWidth: 4
        }
      })
      this.hereMap.addObject(routeLine)
      this.hereMap.getViewModel().setLookAtData({
        bounds: routeLine.getBoundingBox(),
        zoom: 7
      })
    },
    drawHereMapMarkers (markers) {
      let group = new window.H.map.Group()
      group.addObjects(markers)
      this.hereMap.addObject(group)
    },
    drawHereMapMarkersBubbles (markers) {
      // let group = new window.H.map.Group()
      markers.forEach((marker, index) => {
        marker.addEventListener('tap', (evt) => {
          let bubble = new window.H.ui.InfoBubble(marker.getGeometry(), {
            content: marker.getData()
          })
          this.hereMapUI.source.addBubble(bubble)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#map-container {
  width: 100%;
  height: 100%;
  min-height: 500px;
}
</style>
